import store from '../store'
import { makePostRequest } from '@/helper/requests'

export function generateListUidToName (form, nameUid, nameNew, finalizer = () => {
}) {
  /**
   * Заменяет UID пользователей на их ФИО в массиве объектов
   * @param {Array} form - массив объектов с данными пользователей
   * @param {string} nameUid - имя поля, содержащего UID пользователей
   * @param {string} nameNew - имя нового поля для сохранения ФИО
   * @param {Function} finalizer - функция обратного вызова после завершения
   */

  const users = []
  for (const i in form) {
    users.push(form[i][nameUid])
  }
  const url = store.getters['urls/getPattern'](
    process.env.VUE_APP_ACCOUNTS_PREFIX.replace('/', ''),
    'users|user|fio',
    'post'
  )

  makePostRequest(
    process.env.VUE_APP_API_HOST + process.env.VUE_APP_ACCOUNTS_PREFIX.replace('/', '') + url, { uids: users }
  )
    .then(resp => resp.json())
    .then(json => {
      for (const i in json) {
        const replaced = form.filter((item) => item[nameUid] === json[i].value)
        if (replaced.length > 0) {
          for (const j in replaced) {
            replaced[j][nameNew] = json[i].text
          }
        }
      }
      finalizer(form)
    })
}

export function generateUidToName (DataUser, Uid, UserName, finalizer = () => {
}) {
  /**
   * Получает ФИО пользователя по UID и сохраняет в объекте
   * @param {Object} DataUser - объект с данными пользователя
   * @param {string} Uid - имя поля, содержащего UID пользователя
   * @param {string} UserName - имя поля для сохранения ФИО пользователя
   * @param {Function} finalizer - функция обратного вызова после завершения
   */
  const users = []
  users.push(DataUser[Uid])
  const url = store.getters['urls/getPattern'](
    process.env.VUE_APP_ACCOUNTS_PREFIX.replace('/', ''),
    'users|user|fio',
    'post'
  )

  makePostRequest(
    process.env.VUE_APP_API_HOST + process.env.VUE_APP_ACCOUNTS_PREFIX.replace('/', '') + url, { uids: users }
  )
    .then(resp => resp.json())
    .then(json => {
      for (const i in json) {
        DataUser[UserName] = json[i].text
      }
      finalizer(DataUser)
    })
}
